export default __webpack_public_path__ + "static/media/1_2_logo.68c00dec.png";